import { render, staticRenderFns } from "./PhoneRow.vue?vue&type=template&id=1fa0c3b5&"
import script from "./PhoneRow.ts?vue&type=script&lang=ts&"
export * from "./PhoneRow.ts?vue&type=script&lang=ts&"
import style0 from "./PhoneRow.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports